import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { EditVideo, Media, MediaFolder, Program, Video } from "../../../types";
import {
  Modal,
  ModalBody,
  ModalClose,
  ModalHeader,
  ModalTitle,
} from "../../UI/Modal";
import VideoForm from "../VideoForm";

type Props = {
  video: Video | null;
  isOpen: boolean;
  isSubmitting: boolean;
  defaultSeason: number | null;
  defaultEpisodeNumber: number | null;
  program?: Program;
  medias: Media[];
  onClose: () => void;
  onSubmit: (data: EditVideo) => void;
  onChangeFolder: (folderId: MediaFolder["projectId"]) => void;
};

const VideoModal: FC<Props> = ({
  video,
  isOpen,
  isSubmitting,
  defaultEpisodeNumber,
  defaultSeason,
  program,
  medias,
  onClose,
  onSubmit,
  onChangeFolder,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={isOpen} onClose={() => {}}>
      <ModalHeader>
        <ModalTitle>
          {video
            ? t("components.screenProgramDetail.videoModal.typeEdit")
            : t("components.screenProgramDetail.videoModal.typeNew")}
        </ModalTitle>
        <ModalClose onClose={onClose}>x</ModalClose>
      </ModalHeader>
      <ModalBody>
        <VideoForm
          isSubmitting={isSubmitting}
          editable
          isAdmin
          onSubmit={(data: any) => onSubmit(data)}
          validable={false}
          onCancel={onClose}
          video={video}
          defaultSeason={defaultSeason}
          defaultEpisodeNumber={defaultEpisodeNumber}
          onChangeFolder={onChangeFolder}
          medias={medias}
          program={program}
        />
      </ModalBody>
    </Modal>
  );
};

export default VideoModal;
